<template>
    <div v-loading="loading">
        <div ref="customerLevelChart" :style="{ height: map_height, width: '100%' }"></div>
    </div>
</template>
  
<script>
import OrderCount from "~/services/OrderCount";
import echarts from "echarts";

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        map_height:{
            type: String,
            default: '385px',
        }
    },
    data() {
        return {
            loading: false,
        };
    },
    created(){
        this.getData(this.params);
    },
    mounted() {
        
    },
    methods: {
        getData(params) {
            this.loading = true;
            OrderCount.getCustomerLevel(params).then((res) => {
                if (res.code == 0) {
                    //初始化地图
                    this.count_data = res.data;
                    this.initChart();
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
        initChart() {
            if (this.count_data.length == 0) {
                return false;
            }
            const chartContainer = this.$refs.customerLevelChart;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);
            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3dac78",
                ],
                // title: {
                //   text: 'Referer of a Website',
                //   subtext: 'Fake Data',
                //   left: 'center'
                // },
                tooltip: {
                trigger: "item",
                },
                // legend: {
                //   orient: 'vertical',
                //   left: 'left'
                // },
                series: [
                {
                    // name: 'Access From',
                    type: "pie",
                    radius: "70%",
                    data: this.count_data,
                    emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                    },
                },
                ],
            };
            myChart.setOption(option);
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/echarts/customerLevelChart.vue